import { connect } from 'react-redux';
import {
  getDashboardEventsGroupColumn,
  getDashboardEventView,
  getDashboardEventOptions,
} from '../../../../../reducers/analyticsApp';
import { dateFields } from '../../../../../utils/event/common';
import { views } from '../../../../../constants/event';
import ExecutionOptionsBar from '../../../../../components/common/ExecutionOptionsBar';
import {
  changeEventView,
  toggleAdaptive,
  toggleAverageLine,
  toggleCalcTotal,
  toggleMedianLine,
  toggleTrendLine,
  setEventColumnChartSorting,
  toggleCumulative,
} from '../../../../../actions/dashboards/events';
import {
  changeAdaptive,
  onChangeSorting,
  toggleAverage,
  toggleGrandTotal,
  toggleMedian,
  toggleTrend,
} from '../../../../../actions/chart';

export const getViews = (group) =>
  dateFields.includes(group)
    ? [views.CHART, views.STACKED_CHART, views.PERCENTAGE_CHART, views.TABLE]
    : [views.COLUMN_CHART, views.TABLE, views.PIE_CHART];

export const getView = (currentView, result) => {
  const eventViews = getViews(result);
  return eventViews.includes(currentView) ? currentView : eventViews[0];
};

const mapStateToProps = (state, { unitId }) => {
  const group = getDashboardEventsGroupColumn(state, unitId);
  const eventOptions = getDashboardEventOptions(state, unitId);
  const currentView = getDashboardEventView(state, unitId);
  const view = getView(currentView, group);

  return {
    options: {
      ...eventOptions,
      view,
      views: getViews(group),
    },
  };
};

const mapDispatchToProps = (dispatch, { unitId }) => ({
  onChangeView: (view) => dispatch(changeEventView(unitId, view)),
  onChangeSorting: (sorting) =>
    onChangeSorting(sorting, () => dispatch(setEventColumnChartSorting(unitId, sorting))),
  toggleGrandTotal: (e, columnChartSorting) =>
    toggleGrandTotal(e, columnChartSorting, () => dispatch(toggleCalcTotal(unitId))),
  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleTrendLine(unitId))),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleAverageLine(unitId))),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleMedianLine(unitId))),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleAdaptive(unitId))),
  toggleCumulative: () => dispatch(toggleCumulative(unitId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionOptionsBar);
